const initialState = {
  customerSelected: {},
  newCustomerNote: {},
  createChatNoteForWs: false,
  createChatNoteForMsn: false,
  createChatNoteForIg: false,
  customerUpdated: {},
  selectedAnswerMessage: {},
  recordingAudio: false,
  openedNote: false
};

const chatsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_RECORDING_AUDIO':
      return {
        ...state,
        recordingAudio: action.data
      };
    case 'UPDATE_SELECTED_ANSWER_MESSAGE':
      return {
        ...state,
        selectedAnswerMessage: action.data
      };
    case 'SET_CUSTOMER_SELECTED_FOR_CHATS':
      return {
        ...state,
        customerSelected: action.data.customer
      };
    case 'REMOVE_CUSTOMER_SELECTED_FOR_CHATS':
      return {
        ...state,
        customerSelected: {}
      };
    case 'SET_NEW_CUSTOMER_NOTE':
      return {
        ...state,
        newCustomerNote: action.data.note
      };
    case 'EMPTY_CUSTOMER_NOTE':
      return {
        ...state,
        newCustomerNote: {}
      };
    case 'SET_CREATE_CHAT_NOTE_FOR_WS':
      return {
        ...state,
        createChatNoteForWs: action.data.openModal
      };
    case 'SET_CREATE_CHAT_NOTE_FOR_MSN':
      return {
        ...state,
        createChatNoteForMsn: action.data.openModal
      };
    case 'SET_CREATE_CHAT_NOTE_FOR_IG':
      return {
        ...state,
        createChatNoteForIg: action.data.openModal
      };
    case 'SET_CUSTOMER_UPDATED_FOR_CHATS':
      return {
        ...state,
        customerUpdated: action.data.customer
      };
    case 'EMPTY_CUSTOMER_UPDATED_FOR_CHATS':
      return {
        ...state,
        customerUpdated: {}
      };
    case 'OPENED_NOTES':
      return {
        ...state,
        openedNote: action.openedNote
      };
    default:
      return state;
  }
};

export default chatsReducer;
